var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Row, RequiredText } from '../../Input';
import { useToggles } from '../Providers/Toggles';
export var Toggles = function () {
    var _a = useToggles(), requiredToggles = _a.requiredToggles, showRequired = _a.showRequired, toggles = _a.toggles, setToggle = _a.setToggle;
    return (_jsx(_Fragment, { children: (requiredToggles || []).map(function (_a) {
            var id = _a.id, label = _a.label;
            return (_jsxs(Row, __assign({ style: { alignItems: 'center' } }, { children: [_jsx(Checkbox, { label: label, id: id, name: id, checked: toggles[id] || false, onChange: function (ev) { return setToggle(id, ev.target.checked); } }), showRequired[id] ? _jsx(RequiredText, { children: "REQUIRED" }) : null] }), id));
        }) }));
};
//# sourceMappingURL=Toggles.js.map